export default function()
{
    const self = this;

    /**
     * The link selector of lightbox items
     * @type {String}
     */
    self.linkSelector = null;

    /**
     * Set the link selector
     * @param {String} selector
     * @return {void}
     */
    self.setLinkSelector = selector => {
        self.linkSelector = selector;
    };

    /**
     * Enable the lightbox script
     * @return {void}
     */
    self.enable = () => {
        if (self.linkSelector === null) {
            return;
        }

        //$(self.linkSelector).simpleLightbox();
        $(self.linkSelector).magnificPopup({
            type: 'image',
            gallery: {
                enabled: true,
                tCounter: '<span class="mfp-counter">%curr% van %total%</span>',
            },
        });
    };
}



// WEBPACK FOOTER //
// ./resources/js/MrMovie/Lightbox.js